import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  iconBg?: string;
  className?: string;
  /** Compact density for dashboard strips. */
  size?: "default" | "sm";
}

export function StatCard({
  icon,
  label,
  value,
  iconBg = "bg-primary/10 text-primary",
  className,
  size = "default",
}: StatCardProps) {
  const compact = size === "sm";

  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-lg border border-slate-200 bg-white",
        compact ? "px-3 py-2.5" : "px-4 py-3",
        className
      )}
    >
      <div
        className={cn(
          "flex shrink-0 items-center justify-center rounded-lg",
          compact ? "h-8 w-8" : "h-10 w-10",
          iconBg
        )}
      >
        {icon}
      </div>
      <div className="min-w-0">
        <p
          className={cn(
            "font-bold tabular-nums text-slate-900 truncate",
            compact ? "text-base sm:text-lg" : "text-2xl"
          )}
        >
          {value}
        </p>
        <p className={cn("text-slate-500", compact ? "text-xs" : "text-sm")}>{label}</p>
      </div>
    </div>
  );
}
